import * as angular from "angular";

angular
.module('bringoz.admin.oms')
.component('omsOrderStatus', {
  bindings: {
    status: '<'
  },
  template: require('./oms-order-status.html').default
});
